/**
@license
Copyright (c) 2023 Advensys LLC. All rights reserved.
*/

import {
  createSlice
} from '@reduxjs/toolkit'

import { createSelector } from 'reselect';
import { legalcasesSelector } from './legalcasesSlice.js';

import { dataurl } from '../components/paksh-constants.js'

const initialState = {
  isFetching: false,
  failure: false,
  item: {},
  id : "",
};

const idSelector = state => state.legalcase.id;
const itemSelector = state => state.legalcase.item;

export const legalcaseSelector = createSelector(
  idSelector,
  legalcasesSelector,
  itemSelector,
  (id, items, item) =>
  //  return items && items[id] || item;
   item

);


export const fetchLegalcase = (id) => (dispatch, getState) => {
  dispatch(legalcaseRequested(id));
  const state = getState();
  const legalcase = state.legalcases && state.legalcases.items && state.legalcases.items[id];
  console.log(legalcase,id)
  // if (legalcase) {
    // case found in state.legalcases.items
  //  dispatch(receiveLegalcase(id));
    // let the calling code know there's nothing to wait for.
  //  return Promise.resolve();
//  } else {
    // fetch case data given the case id.
    // also return a promise to wait for.
    const token = window.localStorage.getItem('token');

    return fetch(`${dataurl}/legalcases/${id}`, {
      method: 'GET',
      headers: {
        'x-access-token': token,
      }
      })
      .then(res => res.json())
      .then(data => {
        if (data.error) {
          dispatch(legalcaseFailed(id));
        } else {
          dispatch(legalcaseReceived(data));
        }
      })
      .catch((e) => dispatch(legalcaseFailed(id)));
//  }

let i;
for (i in legalcaselist) {
   if (legalcaselist[i].id == id) {
  //   return (caselist[i].legalcaseInfo);
     console.log (id,legalcaselist[i].legalcaseInfo)
     dispatch(legalcaseReceived(legalcaselist[i].legalcaseInfo));
   }

}

};

export const legalcaseSlice = createSlice({
  name: 'legalcase',
  initialState,
  reducers: {
    legalcaseRequested(state, action) {
      state.item = null; // reset items
      state.failure = false;
      state.isFetching = true;
      state.id = action.payload.id;
    },
    legalcaseReceived(state, action) {
      console.log("legal case received")
      state.item = action.payload;
      state.id = action.payload.id;
      state.isFetching = false;
    },
    legalcaseFailed(state, action) {
      state.item= null;
      state.failure = true;
      state.isFetching = false;
    },
    legalcaseUpdated(state, action) {
      state.item = action.payload;
      state.id = action.payload.id;
    },
  },
})



export const { legalcaseRequested, legalcaseReceived, legalcaseFailed, legalcaseUpdated } = legalcaseSlice.actions

// Export the slice reducer as the default export
export default legalcaseSlice.reducer